import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class FrontDeskDepartureReport extends AbstractReport {
}

AccessorsMutatorsDecorator(
    'ident',
    'guest_name',
    'check_in',
    'check_out',
    'number_of_nights',
    'number_of_guests',
    'room_type',
    'rooms',
    'status',
    'reservation_id',
    'source_reservation_id',
)(FrontDeskDepartureReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/front-desk/departure-report.model.js